/** @format */

import {Box, Button, Dialog} from '@mui/material';
import {styled} from '@mui/material/styles';

export const SettingsContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: `${theme.spacing(4)} ${theme.spacing(8)}`,
  alignItems: 'flex-start',
  marginTop: theme.spacing(6),
}));

export const FieldsBlock = styled(Box)(({theme}) => ({
  flex: 1,
  maxWidth: '500px',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const FieldWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const FieldLabel = styled(Box)(({theme}) => ({
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '22px',
  letterSpacing: '0.2px',
  color: theme.palette.semantic_dark?.surface.onSurface,
}));

export const InfoCard = styled(Box)(({theme}) => ({
  flex: 1,
  maxWidth: '400px',
  backgroundColor: theme.palette.semantic_dark?.surface.surface2,
  borderRadius: '16px',
  padding: theme.spacing(4),
  display: 'flex',
  alignItems: 'flex-start',
  border: 'none',
  outline: 'none',
  boxShadow: 'none',
}));

export const InfoCardContent = styled(Box)(({theme}) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const InfoCardTitle = styled(Box)(({theme}) => ({
  fontWeight: 400,
  fontSize: '24px',
  lineHeight: '28px',
  color: theme.palette.semantic_dark?.surface.onSurface,
}));

export const InfoCardText = styled(Box)(({theme}) => ({
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '14px',
  color: theme.palette.semantic_dark?.surface.onSurface,
}));

export const InfoCardList = styled(Box)(({theme}) => ({
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '14px',
  color: theme.palette.semantic_dark?.surface.onSurface,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  '& ul': {
    margin: 0,
    padding: 0,
    paddingLeft: '18px',
    listStyleType: 'disc',
    '& li': {
      fontSize: '12px',
      lineHeight: '14px',
      margin: 0,
      padding: 0,
    },
  },
}));

export const InfoCardIcon = styled(Box)(({theme}) => ({
  '&.material-symbols-outlined': {
    fontSize: '72px',
  },
  lineHeight: 0,
  color: theme.palette.semantic_dark?.surface.onSurfaceLight,
  flexShrink: 0,
}));

export const ConfirmDialog = styled(Dialog)(({theme}) => ({
  '& .MuiDialog-paper': {
    background: theme.palette.semantic_dark?.surface.surface2,
    color: theme.palette.semantic_dark?.surface.onSurface,
    borderRadius: '16px',
  },
  '& .MuiDialogTitle-root': {
    color: theme.palette.semantic_dark?.surface.onSurface,
  },
  '& .MuiDialogContentText-root': {
    color: theme.palette.semantic_dark?.surface.onSurfaceLight,
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(4),
  },
}));

export const GoalPickerButton = styled(Button)(({theme}) => ({
  borderRadius: '8px',
  backgroundColor: theme.palette.figma_gray_dark_1?.main,
  minHeight: '48px',
  width: '100%',
  justifyContent: 'space-between',
  textAlign: 'left',
  textTransform: 'none',
  paddingInline: theme.spacing(4),
  color: theme.palette.text.primary,
  fontSize: '18px',
  fontWeight: 400,
  '&:hover': {
    backgroundColor: theme.palette.figma_gray_dark_1?.main,
    opacity: 0.9,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.figma_gray_dark_1?.main,
    color: theme.palette.text.disabled,
  },
}));
